/* Product media is generated from the feed; this file only adds interaction. */
document.querySelectorAll('.product-media-gallery').forEach(function (gallery) {
  var image = gallery.querySelector('.product-detail-img-wrap img');
  var thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
  var error = gallery.querySelector('.gallery-error');
  if (!image || !thumbnails.length) return;

  function selectPhoto(button) {
    if (error) error.hidden = true;
    image.src = button.dataset.galleryImage;
    image.alt = button.dataset.galleryAlt;
    thumbnails.forEach(function (thumb) {
      var active = thumb === button;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  }
  thumbnails.forEach(function (button, index) {
    button.addEventListener('click', function () { selectPhoto(button); });
    button.addEventListener('keydown', function (event) {
      var next;
      if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + thumbnails.length) % thumbnails.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = thumbnails.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      thumbnails[next].focus({ preventScroll: true });
      selectPhoto(thumbnails[next]);
    });
  });
  image.addEventListener('error', function () { if (error) error.hidden = false; });
  image.addEventListener('load', function () { if (error) error.hidden = true; });
});

document.querySelectorAll('[data-video-dialog]').forEach(function (button) {
  var dialog = document.getElementById(button.dataset.videoDialog);
  var iframe = dialog && dialog.querySelector('iframe[data-video-src]');
  if (!dialog || !iframe) return;
  button.addEventListener('click', function () {
    iframe.src = iframe.dataset.videoSrc;
    if (!dialog.open) dialog.showModal();
  });
  dialog.addEventListener('close', function () { iframe.removeAttribute('src'); });
});
